var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 46.5C15.9627 46.5 46.5 55.5224 46.5 93C46.5 55.5224 77.0373 46.5 93 46.5C55.5224 46.5 46.5 15.9627 46.5 0C46.5 15.9627 37.4776 46.5 0 46.5Z",
    fill: "#31D054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrity);
export default __webpack_public_path__ + "static/media/integrity.0d626def15f2b268f0b605ee3c4a75a8.svg";
export { ForwardRef as ReactComponent };